import Link from 'next/link'
export default function Breadcrumbs({ paths }) {
    return (
        <div className="flex space-x-1 text-md tracking-tighter overflow-y-auto">
            {paths.map(({ label, url }, index) => (
                <Link href={url}>
                    <a className="flex space-x-1 items-center text-gray-800">
                        <p className="whitespace-nowrap">{ label }</p>
                        { paths.length !== index + 1 && (
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                            </svg>
                        )}
                    </a>
                </Link>
            ))}
        </div>
    )

}
